import { Component, Input } from "@angular/core";
import { Conversation } from "src/app/interfaces/conversation";
import { Sale } from "src/app/interfaces/sale";

@Component({
  selector: "app-tooltip",
  templateUrl: "./tooltip.component.html",
  styleUrls: ["./tooltip.component.scss"],
})
export class TooltipComponent {
  @Input() text: string = "";
  @Input() left: number = 0;
  @Input() top: number = 0;
  @Input() position: "top" | "bottom" | "left" | "right" = "right";
  @Input() selectedConversation = {} as Conversation;
  @Input() customerSales: Sale[] = [];
  @Input() saleCount!: number;
  @Input() lastSaleDate!: string;
  @Input() detailAddressUser = "";

  formatPhoneNumber(phoneNumber: string): string {
    const cleaned = ("" + phoneNumber).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{2})(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "+" + match[1] + " " + match[2] + " " + match[3] + " " + match[4];
    }
    return phoneNumber;
  }

  getTimeAgo(date: string | undefined): string {
    if (!date) return "-";
    const now = new Date();
    const pastDate = new Date(date);
    const diffInMs = now.getTime() - pastDate.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInWeeks = Math.floor(diffInDays / 7);
    const diffInMonths = Math.floor(diffInDays / 30);

    if (diffInDays < 1) {
      return "Hace menos de un día";
    } else if (diffInDays === 1) {
      return "Hace 1 día";
    } else if (diffInDays < 7) {
      return `Hace ${diffInDays} días`;
    } else if (diffInWeeks === 1) {
      return "Hace 1 semana";
    } else if (diffInWeeks < 4) {
      return `Hace ${diffInWeeks} semanas`;
    } else if (diffInMonths === 1) {
      return "Hace 1 mes";
    } else {
      return pastDate.toLocaleDateString();
    }
  }
}
